import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGate from './auth/AuthGate';
import Layout from './app/Layout';
import HomeMenu from './app/HomeMenu';
import DeviceEditor from './modules/device-editor/DeviceEditor';
import OrdersPage from './modules/orders/OrdersPage';
import ImportPage from './modules/orders/ImportPage';
import KpisPage from './modules/kpis/KpisPage';
import CountryByYear from './modules/kpis/reports/CountryByYear';
import RegionByYear from './modules/kpis/reports/RegionByYear';
import ChannelByYear from './modules/kpis/reports/ChannelByYear';
import YearOnYear from './modules/kpis/reports/YearOnYear';
import ChannelYoY from './modules/kpis/reports/ChannelYoY';
import ChannelTrend from './modules/kpis/reports/ChannelTrend';
import SettingsPage from './modules/settings/SettingsPage';

/**
 * App shell: authentication guard wrapping a router with the front-page menu
 * and the three admin areas (Device Admin / Order Admin / KPIs).
 */
export default function App() {
  return (
    <AuthGate>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomeMenu />} />
            <Route path="devices" element={<DeviceEditor />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/import" element={<ImportPage />} />
            <Route path="kpis" element={<KpisPage />} />
            <Route path="kpis/country" element={<CountryByYear />} />
            <Route path="kpis/region" element={<RegionByYear />} />
            <Route path="kpis/channel" element={<ChannelByYear />} />
            <Route path="kpis/yoy" element={<YearOnYear />} />
            <Route path="kpis/channel-yoy" element={<ChannelYoY />} />
            <Route path="kpis/channel-trend" element={<ChannelTrend />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthGate>
  );
}
